export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_USER_SUCCESSFUL = "REGISTER_USER_SUCCESSFUL"
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED"
export const REGISTER_USER_API_ERROR = "REGISTER_USER_API_ERROR"
export const REGISTER_USER_RESET = "REGISTER_USER_RESET"
export const REGISTER_USER_RESEND = "REGISTER_USER_RESEND"
export const FETCH_COUNTRY_LIST = "FETCH_COUNTRY_LIST"
export const RESET_REGISTER_RESPONSE_MSG = "RESET_REGISTER_RESPONSE_MSG"
export const SET_COUNTRY_LIST = "SET_COUNTRY_LIST"
export const FETCH_COUNTRY_AND_STATES_LIST = "FETCH_COUNTRY_AND_STATES_LIST"
export const SET_COUNTRY_AND_STATES_LIST = "SET_COUNTRY_AND_STATES_LIST"
